module.exports = __webpack_public_path__ + "img/404.6cda0359.svg";